const mixpanel = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default mixpanel;
